/**
 * @prettier
 */

export const STEPS = {
  detailFront: 'detailFront',
  detailInside: 'detailInside',
  detailBack: 'detailBack',
  envelope: 'envelope',
  recipients: 'recipients',
  addressing: 'addressing',
  addressingPreview: 'addressingPreview',
  rsvp: 'rsvp',
  rsvpEnvelope: 'rsvpEnvelope',
  reviewPaper: 'reviewPaper',
};

export const ADDRESSING_STEPS = [STEPS.recipients, STEPS.addressing, STEPS.addressingPreview];

export const STEPS_ALLOWING_MULTIPLES = [STEPS.detailFront, STEPS.detailBack, STEPS.detailInside];



// WEBPACK FOOTER //
// ./src/cards/constants/Steps.js